module.exports = __webpack_public_path__ + "static/images/duplicate.6bb02b4d9ba5ae9c441e11796c056ccd.svg";